import I from "jquery";
import { defineComponent as w, computed as h, ref as E, openBlock as g, createElementBlock as B, normalizeClass as v, withDirectives as V, createElementVNode as c, isRef as k, unref as i, vModelCheckbox as Y, normalizeStyle as q, toDisplayString as y, createCommentVNode as O, onBeforeUnmount as Q, watch as F, onMounted as T, useCssVars as G, inject as Z, renderSlot as M, createTextVNode as K, createVNode as H, Fragment as j, renderList as z, pushScopeId as W, popScopeId as X } from "vue";
import { U as A, B as R, k as s, j as r } from "./NaturalCompare-BhqAyIXe.js";
import "utif2";
import "moment";
import './MessageBoxEx.css';const U = (n, u) => {
  const t = n.__vccOpts || n;
  for (const [a, o] of u)
    t[a] = o;
  return t;
}, P = ["id", "disabled"], J = ["for"], ee = /* @__PURE__ */ w({
  __name: "Checkbox",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    stopPropagation: { type: Boolean, default: !0 },
    labelClass: { default: () => ["default-text-font"] },
    labelStyle: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(n, { emit: u }) {
    const t = n, a = u, o = h({
      get: () => t.modelValue,
      set: (l) => {
        a("update:modelValue", l);
      }
    }), m = E(`Checkbox${A.NewID()}`);
    function _(l) {
      t.stopPropagation && l.stopPropagation();
    }
    return (l, C) => (g(), B("div", {
      class: v(["triStateCheckbox", l.$style.container]),
      onClick: _
    }, [
      V(c("input", {
        type: "checkbox",
        id: i(m),
        "onUpdate:modelValue": C[0] || (C[0] = (p) => k(o) ? o.value = p : null),
        disabled: t.disabled
      }, null, 8, P), [
        [Y, i(o)]
      ]),
      0 < t.label.length ? (g(), B("label", {
        key: 0,
        for: i(m),
        class: v(t.labelClass),
        style: q(t.labelStyle)
      }, y(t.label), 15, J)) : O("", !0)
    ], 2));
  }
}), te = "_container_1794x_3", se = {
  container: te
}, ae = {
  $style: se
}, oe = /* @__PURE__ */ U(ee, [["__cssModules", ae]]);
function De() {
  const n = [];
  function u(a, o) {
    var C, p;
    const m = new MutationObserver((N) => {
      N.forEach((b) => {
        t(I(b.target), o);
      });
    }), _ = {
      attributes: !0,
      attributeFilter: ["style"],
      characterData: !1,
      childList: !1,
      subtree: !1
    };
    m.observe(a, _);
    const l = I(a).closest(".modal, .collapse");
    0 < l.length ? (m.observe(l[0], _), (C = o == null ? void 0 : o.options) != null && C.immediate && t(l, o)) : (p = o == null ? void 0 : o.options) != null && p.immediate && t(I(a), o), n.push(m);
  }
  function t(a, o) {
    a.length <= 0 || (a.is(":hidden") ? o != null && o.onHidden && o.onHidden(a[0]) : o != null && o.onVisibled && o.onVisibled(a[0]));
  }
  return Q(() => {
    n.forEach((a) => a.disconnect());
  }), {
    watchElementVisibility: u
  };
}
function ne(n, u) {
  F(u, () => {
    t(u.value);
  }), T(() => {
    t(u.value);
  });
  function t(o) {
    o ? R.showModal(n) : R.hideModal(n);
  }
  function a() {
    u.value = !1;
  }
  return {
    hideModal: a
  };
}
const le = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='a1908c24-145e-408e-856f-0d237994df40'%20data-name='レイヤー%205'%3e%3ccircle%20cx='120'%20cy='120'%20r='100'%20fill='%23c73e38'/%3e%3cpath%20d='M133.54858,120.00586l33.64551-33.65039A9.53053,9.53053,0,0,0,170,79.6001a9.67191,9.67191,0,0,0-2.80591-6.79395,9.58136,9.58136,0,0,0-13.5498,0L120,106.45508,86.35571,72.80615a9.581,9.581,0,0,0-13.5498,13.54932l33.64551,33.65039L72.80591,153.65625a9.581,9.581,0,0,0,13.5498,13.54932L120,133.55615l33.64429,33.64942a9.581,9.581,0,0,0,13.5498-13.54932Z'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", ce = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='aaa9a38c-f573-4bce-9352-08642897a534'%20data-name='240x240'%3e%3cpath%20d='M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z'%20fill='%231464B9'/%3e%3c/g%3e%3cg%20id='ff48341d-61fa-4f4d-959e-cd143a7c7c13'%20data-name='レイヤー%205'%3e%3cpath%20d='M132.5,177.41167a12.50031,12.50031,0,1,1-25,0,12.50031,12.50031,0,0,1,25,0Z'%20fill='%23fff'/%3e%3cpath%20d='M120,152a9.57967,9.57967,0,0,1-10-10v-3c0-6.77173.95947-16.64178,10.17432-24.52118,1.88672-1.61334,3.8081-3.17175,5.666-4.67889C136.42773,101.212,144.167,97.48175,144.167,88.28418,144.167,79.83075,141.19238,70,120,70c-8.55859,0-25,4-25,20,0,6.41663-4.24707,10.00006-10,10.00006s-10-4.6637-10-10.41669C75,65.90735,93.83154,50,120,50c36.16016,0,45,21.73151,45,38.28418,0,17.71582-14.99268,24.4256-26.03564,33.38275-1.83545,1.489-2.32076,1.852-3.96436,3.33307-2.8741,2.58993-5,7-5,14v3A9.57967,9.57967,0,0,1,120,152Z'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", ie = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='b5278ebe-7d54-48f0-b5e3-60bac60958dc'%20data-name='レイヤー%205'%3e%3cpath%20d='M217.5,177.5,138.69654,41.17667a21.22945,21.22945,0,0,0-37.4125.02916L22.5,177.5a19.67288,19.67288,0,0,0-2.5,10A22.40645,22.40645,0,0,0,42.5,210h155A22.40645,22.40645,0,0,0,220,187.5,19.70264,19.70264,0,0,0,217.5,177.5Z'%20fill='%23fabe50'/%3e%3ccircle%20cx='120'%20cy='177.5'%20r='12.5'%20fill='%23493712'/%3e%3cpath%20d='M128.58154,143.77917C128.21071,147.295,124.46821,150,120.00238,150c-4.47167,0-8.21417-2.705-8.58167-6.22083,0,0-3.92071-62.77917-3.92071-68.94584C107.5,67,111.46667,60,120.00238,60,128.53571,60,132.5,67,132.5,74.83333,132.5,81,128.58154,143.77917,128.58154,143.77917Z'%20fill='%23493712'/%3e%3c/g%3e%3c/svg%3e", de = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20240%20240'%3e%3cg%20id='e55d3ae3-6a81-4989-920b-aa9ca8f4aa9b'%20data-name='240x240'%3e%3cpath%20d='M120,20A100,100,0,1,0,220,120,100,100,0,0,0,120,20Z'%20fill='%231464B9'/%3e%3c/g%3e%3cg%20id='b43da061-7bcf-45ee-a375-515d02cfa0ff'%20data-name='レイヤー%205'%3e%3ccircle%20cx='119.5'%20cy='62.5'%20r='12.5'%20fill='%23fff'/%3e%3crect%20x='107'%20y='90'%20width='25'%20height='100'%20rx='12.49999'%20fill='%23fff'/%3e%3c/g%3e%3c/svg%3e", re = (n) => (W("data-v-e5d13538"), n = n(), X(), n), ue = ["id"], fe = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scv-cmn",
  role: "document"
}, he = { class: "modal-content modal-message-content-scv-cmn new-size" }, me = { class: "modal-header modal-header-scv-cmn" }, _e = { class: "modal-header-text-box-scv-cmn" }, Ce = { class: "modal-header-text-scv-cmn" }, ge = /* @__PURE__ */ re(() => /* @__PURE__ */ c("div", { class: "icon-font-slategray" }, [
  /* @__PURE__ */ c("i", { class: "icon-delete" })
], -1)), Be = [
  ge
], pe = { class: "modal-body modal-body-scv-cmn" }, ve = ["src"], Ne = ["innerHTML"], be = {
  key: 0,
  class: "checkc-area"
}, Ie = { class: "modal-footer modal-footer-scv-cmn" }, Me = ["id", "onClick"], Ee = /* @__PURE__ */ w({
  __name: "MessageBoxEx",
  props: {
    caption: { default: "" },
    flags: { default: s.MB_NO_BUTTON },
    message: { default: "" },
    show: { type: Boolean },
    uniqueButtonCaptions: { default: void 0 },
    useCheck: { type: Boolean, default: !1 },
    checkText: { default: "" },
    checkStatus: { type: Boolean, default: !1 }
  },
  emits: ["update:show", "update:check", "close"],
  setup(n, { emit: u }) {
    G((e) => ({
      e9924c12: i(L)
    }));
    const t = n, a = u, o = h(() => `messageBoxEx${A.NewID()}`), m = Z("$show", E(null)), { hideModal: _ } = ne(o.value, h({
      get: () => m.value ?? t.show,
      set: (e) => a("update:show", e)
    })), l = E(!1), C = h(() => {
      if (t.caption)
        return t.caption;
      switch (t.flags & 240) {
        case s.MB_ICONERROR:
          return "エラー";
        case s.MB_ICONQUESTION:
          return "確認";
        case s.MB_ICONWARNING:
          return "警告";
        case s.MB_ICONINFORMATION:
          return "情報";
        default:
          return "";
      }
    }), p = [
      // [中止]
      {
        caption: "中止",
        handler: () => a("close", r.IDABORT),
        condition: (e) => s.MB_ABORTRETRYIGNORE === e
      },
      // [はい]
      {
        caption: "はい",
        handler: () => a("close", r.IDYES),
        condition: (e) => s.MB_YESNOCANCEL === e || s.MB_YESNO === e,
        styleClass: "btn-scv-blue"
      },
      // [いいえ]
      {
        caption: "いいえ",
        handler: () => a("close", r.IDNO),
        condition: (e) => s.MB_YESNOCANCEL === e || s.MB_YESNO === e
      },
      // [リトライ]
      {
        caption: "リトライ",
        handler: () => a("close", r.IDRETRY),
        condition: (e) => s.MB_RETRYCANCEL === e || s.MB_ABORTRETRYIGNORE === e,
        styleClass: "btn-scv-blue"
      },
      // [OK]
      {
        caption: "OK",
        handler: () => a("close", r.IDOK),
        condition: (e) => s.MB_OK === e || s.MB_OKCANCEL === e,
        styleClass: "btn-scv-blue"
      },
      // [キャンセル]
      {
        caption: "キャンセル",
        handler: () => a("close", r.IDCANCEL),
        condition: (e) => s.MB_OKCANCEL === e || s.MB_YESNOCANCEL === e || s.MB_RETRYCANCEL === e || s.MB_CANCELTRYCONTINUE === e
      },
      // [再実行]
      {
        caption: "再実行",
        handler: () => a("close", r.IDTRYAGAIN),
        condition: (e) => s.MB_CANCELTRYCONTINUE === e,
        styleClass: "btn-scv-blue"
      },
      // [続行]
      {
        caption: "続行",
        handler: () => a("close", r.IDCONTINUE),
        condition: (e) => s.MB_CANCELTRYCONTINUE === e,
        styleClass: "btn-scv-blue"
      },
      // [無視]
      {
        caption: "無視",
        handler: () => a("close", r.IDIGNORE),
        condition: (e) => s.MB_ABORTRETRYIGNORE === e
      },
      // [固有ボタン1]
      {
        caption: t.uniqueButtonCaptions ? t.uniqueButtonCaptions[0] : "",
        handler: () => a("close", r.IDUNIQUE1),
        condition: (e) => t.uniqueButtonCaptions ? s.MB_UNIQUE === e && t.uniqueButtonCaptions.length >= 1 : !1,
        styleClass: "btn-scv-blue"
      },
      // [固有ボタン2]
      {
        caption: t.uniqueButtonCaptions ? t.uniqueButtonCaptions[1] : "",
        handler: () => a("close", r.IDUNIQUE2),
        condition: (e) => t.uniqueButtonCaptions ? s.MB_UNIQUE === e && t.uniqueButtonCaptions.length >= 2 : !1
      },
      // [固有ボタン3]
      {
        caption: t.uniqueButtonCaptions ? t.uniqueButtonCaptions[2] : "",
        handler: () => a("close", r.IDUNIQUE3),
        condition: (e) => t.uniqueButtonCaptions ? s.MB_UNIQUE === e && t.uniqueButtonCaptions.length >= 3 : !1
      }
    ], N = h(() => p.filter((d) => d.condition(t.flags & 15))), b = h(() => (e) => e.styleClass ? e.styleClass : "btn-scv-white"), S = h(() => {
      switch (t.flags & 240) {
        case s.MB_ICONERROR:
        case s.MB_ICONQUESTION:
        case s.MB_ICONWARNING:
        case s.MB_ICONINFORMATION:
          return !0;
        default:
          return !1;
      }
    }), D = h(() => {
      switch (t.flags & 240) {
        case s.MB_ICONERROR:
          return le;
        case s.MB_ICONQUESTION:
          return ce;
        case s.MB_ICONWARNING:
          return ie;
        case s.MB_ICONINFORMATION:
          return de;
        default:
          return "";
      }
    }), L = h(() => !t.message || 1 < t.message.replace(/\r?\n/g, "<br />").split("<br />").length ? "start" : "center");
    T(() => {
      const e = t.flags >> 8 & 15;
      if (e != s.MB_NO_DEFBUTTON) {
        const d = document.getElementById(o.value), f = d == null ? void 0 : d.querySelector("#messageBoxEXbutton" + e);
        d == null || d.addEventListener("shown.bs.modal", () => {
          f == null || f.focus();
        });
      }
      t.checkStatus !== void 0 && (l.value = t.checkStatus);
    });
    const $ = h(() => () => {
      a("update:check", l.value);
    });
    return (e, d) => (g(), B("div", {
      class: "modal fade",
      id: i(o),
      tabindex: "-1",
      role: "dialog",
      "aria-labelledby": "modalFileUpload",
      "aria-hidden": "true",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      c("div", fe, [
        c("div", he, [
          c("div", me, [
            c("div", _e, [
              c("div", Ce, [
                M(e.$slots, "title", {}, () => [
                  K(y(i(C)), 1)
                ], !0)
              ])
            ]),
            c("a", {
              class: "btn-scv-cmn-close",
              onClick: d[0] || (d[0] = (f) => {
                i(_)(), a("close", i(r).IDCANCEL);
              })
            }, Be)
          ]),
          c("div", pe, [
            c("div", {
              class: v(e.$style.body)
            }, [
              i(S) ? (g(), B("img", {
                key: 0,
                src: i(D),
                height: "24"
              }, null, 8, ve)) : O("", !0),
              c("div", null, [
                M(e.$slots, "default", {}, () => [
                  c("div", {
                    innerHTML: t.message
                  }, null, 8, Ne)
                ], !0)
              ])
            ], 2),
            t.useCheck ? (g(), B("div", be, [
              H(oe, {
                label: t.checkText,
                modelValue: i(l),
                "onUpdate:modelValue": [
                  d[1] || (d[1] = (f) => k(l) ? l.value = f : null),
                  i($)
                ]
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ])) : O("", !0)
          ]),
          c("div", Ie, [
            M(e.$slots, "footer", {}, () => [
              c("div", {
                class: v(e.$style.footer)
              }, [
                (g(!0), B(j, null, z(i(N), (f, x) => (g(), B("button", {
                  key: x,
                  id: "messageBoxEXbutton" + (x + 1),
                  class: v(i(b)(f)),
                  onClick: (we) => {
                    i(_)(), f.handler();
                  }
                }, y(f.caption), 11, Me))), 128))
              ], 2)
            ], !0)
          ])
        ])
      ])
    ], 8, ue));
  }
}), ye = "_body_1c8kf_5", Oe = "_footer_1c8kf_45", xe = {
  body: ye,
  footer: Oe
}, Re = {
  $style: xe
}, Le = /* @__PURE__ */ U(Ee, [["__cssModules", Re], ["__scopeId", "data-v-e5d13538"]]);
export {
  oe as C,
  Le as M,
  U as _,
  ne as a,
  de as b,
  De as u
};
